import React from "react";

import { universityCourseMutedTextClassName } from "./courseOverviewCardShell";

type CourseOverviewProgressProps = {
  value: number;
  label?: string;
};

export function CourseOverviewProgress({
  value,
  label = "Course progress",
}: CourseOverviewProgressProps): React.ReactElement {
  const clamped = Math.min(100, Math.max(0, value));

  return (
    <div data-university-course-progress="" className="min-w-[200px]">
      <p
        data-university-course-muted=""
        className={`mb-1 text-xs ${universityCourseMutedTextClassName}`}
      >
        {label}
      </p>
      <div
        data-university-progress=""
        className="h-2 w-full overflow-hidden rounded-full bg-muted"
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className="h-full rounded-full bg-[image:var(--gradient-primary)] transition-[width]"
          style={{ width: `${clamped}%` }}
        />
      </div>
      <p data-university-course-muted="" className={`mt-1 text-xs ${universityCourseMutedTextClassName}`}>
        {Math.round(clamped)}% complete
      </p>
    </div>
  );
}
